<template>
    <page-content
        :loading="isLoading"
        :error="error"
    >
        <v-container
            v-if="productReturn"
            grid-list-lg
        >
            <h1 class="display-1 mb-1">
                Edit Product Return
            </h1>
            <v-layout
                row
                wrap
            >
                <v-flex
                    xs12
                    sm8
                >
                    <return-wizard
                        v-if="productReturn"
                        :product-return="productReturn"
                        is-edit
                        @updated="onUpdate"
                    />
                </v-flex>
                <v-flex
                    xs12
                    sm4
                >
                    <invoice-card
                        v-if="invoiceCard"
                        :invoice="invoiceCard"
                    />
                </v-flex>
            </v-layout>
        </v-container>
    </page-content>
</template>

<script>
import axios from 'axios'
import { requestErrorMessage } from '../utils/constants/errors'
import ReturnWizard from '../components/ReturnWizard'
import InvoiceCard from '../components/InvoiceCard'
import { statuses, OPEN } from '../utils/constants/statuses'

export default {
    components: {
        ReturnWizard,
        InvoiceCard
    },
    data () {
        return {
            isLoading: false,
            error: null,
            invoice: null,
            invoiceCard: null,
            productReturn: null
        }
    },
    created () {
        this.isLoading = true

        axios.get('/api/returns/' + this.$route.params.id)
            .then(res => {
                this.productReturn = res.data

                if (this.productReturn.status !== OPEN) {
                    this.error = 'Return can not be edited while status is ' + statuses[OPEN].text
                    return
                }

                const metadata = res.data.metadata || {}
                this.invoiceCard = {
                    invoiceNumber: res.data.invoiceNumber,
                    partnerNumber: metadata.partnerNumber,
                    amountPaid: metadata.amountPaid,
                    salesRep: metadata.salesRep,
                    projectName: metadata.projectName
                }
                this.comments = res.data.comments
            })
            .catch(err => {
                console.log('Read Return Error', err)
                this.error = requestErrorMessage
            })
            .finally(() => {
                this.isLoading = false
            })
    },
    methods: {
        onUpdate () {
            // return to read page after successful update
            this.$router.push({ name: 'readReturn', params: { id: this.$route.params.id } })
        }
    }
}
</script>

<style>

</style>
